<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div
        class="d-inline-flex align-center overflow-hidden"
        v-bind="attrs"
        v-on="on"
      >
        <template v-if="!imageError">
          <v-progress-circular
            v-if="loading"
            indeterminate
            :size="computedSize * 0.5"
            :width="2"
            color="primary"
          ></v-progress-circular>
          <template v-else>
            <img
              v-bind:alt="line?.label"
              :height="size"
              :src="imgUrl"
              @error="imageError = true"
            />
          </template>
        </template>
        <template v-else>
          <v-avatar class="rounded-sm" color="#a5abb0" :size="computedSize">
            <v-icon small dark> mdi-ferry </v-icon>
          </v-avatar>
        </template>
      </div>
    </template>
    <span>{{ line?.label || 'N/A' }}</span>
  </v-tooltip>
</template>
<script>
import firebase from 'firebase';
import { getLineById } from '@qualle-admin/qutil/dist/ssl';

export default {
  name: 'BaseAppLineAvatar',
  props: {
    line: {
      default: () => null,
    },
    size: {
      default: () => 36,
      type: Number,
    },
  },
  data() {
    return {
      imgUrl: null,
      imageError: false,
      loading: false,
    };
  },
  computed: {
    computedSize: {
      get() {
        return this.size > 24 ? 36 : 28;
      },
    },
  },
  methods: {
    async getImgUrl() {
      this.loading = true;

      const lineId = getLineById(this.line?.id)?.id;

      if (lineId) {
        const images = firebase.storage().ref().child('assets/ssl');

        try {
          const image = images.child(`${lineId}.png`);

          if (image) {
            try {
              this.imgUrl = await image.getDownloadURL();

              this.loading = false;
              this.imageError = false;
              this.$forceUpdate();
            } catch (e) {
              this.handleError();
            }
          }
        } catch (e) {
          this.handleError();
        }
      } else {
        this.handleError();
      }
    },
    handleError() {
      this.imageError = true;
      this.loading = false;
    },
  },
  async mounted() {
    await this.getImgUrl();
  },
  watch: {
    async line() {
      await this.getImgUrl();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
</style>
